module.exports = __webpack_public_path__ + "static/img/irole.996872b.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/mz/irole.png
// module id = GVIk
// module chunks = 7